let LeafIcon = L.Icon.extend({
  options: {},
});
let iconoLogo = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/Content/img/iconosmapa/logo.png",
  iconSize: [45, 45],
});
let iconoRestaurante = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoRestaurante.svg",
  iconSize: [35, 35],
});
let iconoBanos = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoBanos.svg",
  iconSize: [35, 35],
});
let iconoUser = new LeafIcon({
  iconUrl: "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoUser.svg",
  iconSize: [60, 60],
});

let iconoGanaderia = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoGanaderia.svg",
  iconSize: [45, 45],
});
let iconoEspecies = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoEspecies.svg",
  iconSize: [45, 45],
});

let iconoAvestruz = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoAvestruz.svg",
  iconSize: [45, 45],
});
let iconoPorcicultura = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoPorcicultura.svg",
  iconSize: [45, 45],
});
let iconoFelinos = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoFelinos.svg",
  iconSize: [45, 45],
});
let iconoGranjaIntegral = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoGranjaIntegral.svg",
  iconSize: [45, 45],
});
let iconoCaninos = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoCaninos.svg",
  iconSize: [45, 45],
});
let iconoSericultura = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoSericultura.svg",
  iconSize: [45, 45],
});
let iconoEquinos = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoEquinos.svg",
  iconSize: [45, 45],
});
let iconoParqueadero = new LeafIcon({
  iconUrl:
    "https://grupopanaca.com.co/PortalPanaca/content/img/iconosMarcadores/iconoParqueadero.svg",
  iconSize: [35, 35],
});
let iconoEnfoque = new LeafIcon({
  iconUrl:
    "https://cdn.shopify.com/s/files/1/0607/8726/1659/files/logoCamara_2.svg",
  iconSize: [35, 35],
});
let iconoEnfoqueEquinos = new LeafIcon({
  iconUrl:
    "https://cdn.shopify.com/s/files/1/0607/8726/1659/files/logoCamara_2.svg",
  iconSize: [35, 35],
})

//marcadores para estaciones
let marcadorGanaderia = L.marker([33.952162238024975, -137.97122907466658], {
  icon: iconoGanaderia,
});
let marcadorEspecies = L.marker([21.77589640861529, -85.4984158142574], {
  icon: iconoEspecies,
});
let marcadorAvestruz = L.marker([31.50362930577303, -73.22344763878877], {
  icon: iconoAvestruz,
});
let marcadorPorcicultura = L.marker([51.17934297928929, -74.10248062364818], {
  icon: iconoPorcicultura,
});
let marcadorFelinos = L.marker([38.09998264736481, -12.678954550063077], {
  icon: iconoFelinos,
});
let marcadorGranja = L.marker([36.08466744436186, 23.631780314978368], {
  icon: iconoGranjaIntegral,
});
let marcadorCaninos = L.marker([50.261253827584724, 48.39538530213591], {
  icon: iconoCaninos,
});
let marcadorSericultura = L.marker([47.54687159892238, 76.04968569754868], {
  icon: iconoSericultura,
});
let marcadorEquinos = L.marker([6.970049417296232, 77.14880010251443], {
  icon: iconoEquinos,
});
let marcadorParqueadero1 = L.marker([-32.842673631954305, -85.70571602379236], {
  icon: iconoParqueadero,
});
let marcadorParqueadero2 = L.marker([-33.7243396617476, -48.08310427180967], {
  icon: iconoParqueadero,
});
let marcadorParqueadero3 = L.marker([-38.09998264736479, 10.349098915149606], {
  icon: iconoParqueadero,
});
let marcadorBanoGanaderia = L.marker(
  [28.939892295655216, -144.35183181157626],
  {
    icon: iconoBanos,
  }
);
let marcadorRestauranteGanaderia = L.marker(
  [30.293172045299237, -129.62125216857427],
  {
    icon: iconoRestaurante,
  }
);
let marcadorBanoEspecies = L.marker([14.897046254044808, -75.25927839987384], {
  icon: iconoBanos,
});
let marcadorRestauranteEspecies = L.marker(
  [8.727365473188135, -73.90627605105445],
  {
    icon: iconoRestaurante,
  }
);
let marcadorBanoPorci = L.marker([47.12897173110148, -71.03965392934393], {
  icon: iconoBanos,
});
let marcadorRestaurantePorci = L.marker(
  [43.35431483042233, -74.24648944439438],
  {
    icon: iconoRestaurante,
  }
);
let marcadorRestauranteFelinos = L.marker(
  [41.638371339361775, -3.098578598143469],
  {
    icon: iconoRestaurante,
  }
);
let marcadorRestauranteCaninos = L.marker(
  [36.38124199840125, 48.06114112067411],
  {
    icon: iconoRestaurante,
  }
);

let marcadorBanoEquinos = L.marker([5.569169393527328, 68.85224193966293], {
  icon: iconoBanos,
});
let marcadorRestauranteEquinos = L.marker(
  [3.3332565814598936, 76.8392565451514],
  {
    icon: iconoRestaurante,
  }
);
let numero1 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>1</span>",
});

let numero2 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>2</span>",
});

let numero3 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>3</span>",
});

let numero4 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>4</span>",
});
let numero5 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>5</span>",
});
let numero6 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>6</span>",
});
let numero7 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>7</span>",
});
let numero8 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>8</span>",
});
let numero9 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>9</span>",
});
let numero10 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>10</span>",
});
let numero11 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>11</span>",
});

let numero12 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>12</span>",
});

let numero13 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>13</span>",
});

let numero14 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>14</span>",
});
let numero15 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>15</span>",
});
let numero16 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>16</span>",
});
let numero17 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>17</span>",
});
let numero18 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>18</span>",
});
let numero19 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>19</span>",
});
let numero20 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>20</span>",
});
let numero21 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>21</span>",
});

let numero22 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>22</span>",
});

let numero23 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>23</span>",
});

let numero24 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>24</span>",
});
let numero25 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>25</span>",
});
let numero26 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>26</span>",
});
let numero27 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>27</span>",
});
let numero28 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>28</span>",
});
let numero29 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>29</span>",
});
let numero30 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>30</span>",
});
let numero31 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>31</span>",
});

let numero32 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>32</span>",
});

let numero33 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>33</span>",
});

let numero34 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>34</span>",
});
let numero35 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>35</span>",
});
let numero36 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>36</span>",
});
let numero37 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>37</span>",
});
let numero38 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>38</span>",
});
let numero39 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>39</span>",
});
let numero40 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>40</span>",
});
let numero41 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>41</span>",
});

let numero42 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>42</span>",
});

let numero43 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>43</span>",
});

let numero44 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>44</span>",
});
let numero45 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>45</span>",
});
let numero46 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>46</span>",
});
let numero47 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>47</span>",
});
let numero48 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>48</span>",
});
let numero49 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>49</span>",
});
let numero50 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>50</span>",
});
let numero51 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>51</span>",
});

let numero52 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>52</span>",
});

let numero53 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>53</span>",
});

let numero54 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>54</span>",
});
let numero55 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>55</span>",
});
let numero56 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>56</span>",
});
let numero57 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>57</span>",
});
let numero58 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>58</span>",
});
let numero59 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>59</span>",
});
let numero60 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>60</span>",
});
let numero61 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>61</span>",
});

let numero62 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>62</span>",
});

let numero63 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>63</span>",
});

let numero64 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>64</span>",
});
let numero65 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>65</span>",
});
let numero66 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>66</span>",
});
let numero67 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>67</span>",
});
let numero68 = L.divIcon({
  className: "iconoMarcadores",
  html: "<div class='marker-number'>68</span>",
});

let marcardorEnfoqueEntrada = L.marker([-19.036957934702187, -41.36794873083494], {
  icon: iconoEnfoque,
});
let marcadorEnfoqueEquinos = L.marker([5.573240741612324, 55.65737696509558], {
  icon: iconoEnfoqueEquinos,
})
let marcador1 = L.marker([-41.228249015185305, -89.94663511907446], {
  icon: numero1,
});
let marcador2 = L.marker([-35.96022296929668, -85.83794167098505], {
  icon: numero2,
});
let marcador3 = L.marker([-35.31736632923786, -47.91246212035869], {
  icon: numero3,
});
let marcador4 = L.marker([-23.443088931121775, -55.075804695949], {
  icon: numero4,
});
let marcador5 = L.marker([-21.79793355381083, -46.01253548576066], {
  icon: numero5,
});
let marcador6 = L.marker([-10.984335146101955, -46.11055222602741], {
  icon: numero6,
});
let marcador7 = L.marker([-8.407168163601076, -55.44101337193584], {
  icon: numero7,
});
let marcador8 = L.marker([-17.14079039331665, -57.163983290712885], {
  icon: numero8,
});
let marcador9 = L.marker([-19.43711905557786, -42.551593409224054], {
  icon: numero9,
});
let marcador10 = L.marker([-19.541882510887046, -37.804200626915105], {
  icon: numero10,
});
let marcador11 = L.marker([-27.316511778073302, -43.40774758358867], {
  icon: numero11,
});
let marcador12 = L.marker([-15.182325311366435, -41.51774745685382], {
  icon: numero12,
});
let marcador13 = L.marker([-17.45962346458275, -33.51966889813897], {
  icon: numero13,
});
let marcador14 = L.marker([-25.650998344849743, -28.89420455569575], {
  icon: numero14,
});
let marcador15 = L.marker([-19.445745481065696, -28.368020429659342], {
  icon: numero15,
});
let marcador16 = L.marker([-8.895068892944526, -78.59890036386987], {
  icon: numero16,
});
let marcador17 = L.marker([-4.131101345226565, -86.89229332360763], {
  icon: numero17,
});
let marcador18 = L.marker([30.528427085221384, -138.1942507435112], {
  icon: numero18,
});
let marcador19 = L.marker([32.65704882395219, -133.36487001227923], {
  icon: numero19,
});
let marcador20 = L.marker([29.186305316494057, -150.7158576288753], {
  icon: numero20,
});
let marcador21 = L.marker([29.572036658067045, -133.76090377444575], {
  icon: numero21,
});
let marcador22 = L.marker([28.031040530403907, -127.24792014014061], {
  icon: numero22,
});
let marcador23 = L.marker([15.557013897460111, -85.31028425220802], {
  icon: numero23,
});
let marcador24 = L.marker([14.982738315821825, -93.93648612112473], {
  icon: numero24,
});
let marcador25 = L.marker([7.70254872841724, -87.03607718997837], {
  icon: numero25,
});
let marcador26 = L.marker([3.580716507085973, -82.313213939708], {
  icon: numero26,
});
let marcador27 = L.marker([6.91810511808181, -61.54632581560925], {
  icon: numero27,
});
let marcador28 = L.marker([25.171499303493704, -74.02970946737564], {
  icon: numero28,
});
let marcador29 = L.marker([32.860729403306976, -86.32124822571197], {
  icon: numero29,
});
let marcador30 = L.marker([46.25846848014459, -75.47696453113734], {
  icon: numero30,
});
let marcador31 = L.marker([38.18469014714702, -92.42969418878427], {
  icon: numero31,
});
let marcador32 = L.marker([48.2238204750338, -80.40108907489187], {
  icon: numero32,
});
let marcador33 = L.marker([45.18113523035264, -65.9731902966159], {
  icon: numero33,
});
let marcador34 = L.marker([31.946328431915543, -12.680019122882113], {
  icon: numero34,
});
let marcador35 = L.marker([34.44856438909849, -28.45476410418169], {
  icon: numero35,
});
let marcador36 = L.marker([38.81920972942668, -3.6255991742519815], {
  icon: numero36,
});
let marcador37 = L.marker([32.39022242285579, 19.46974416456382], {
  icon: numero37,
});
let marcador38 = L.marker([45.209270267619, 46.73764264712511], {
  icon: numero38,
});
let marcador39 = L.marker([46.91576200751407, 33.35542368871665], {
  icon: numero39,
});
let marcador40 = L.marker([43.26018312317002, 60.19452427958273], {
  icon: numero40,
});
let marcador41 = L.marker([44.848096761601234, 75.87789025887707], {
  icon: numero41,
});
let marcador42 = L.marker([38.78585272790148, 58.69100844335798], {
  icon: numero42,
});
let marcador43 = L.marker([34.66718873792722, 61.88715070464581], {
  icon: numero43,
});
let marcador44 = L.marker([37.43835993551806, 68.85224510803442], {
  icon: numero44,
});
let marcador45 = L.marker([30.819994056916272, 38.782166011400506], {
  icon: numero45,
});
let marcador46 = L.marker([20.255747154596218, 47.528886394872041], {
  icon: numero46,
});
let marcador47 = L.marker([2.88772368982379, 72.97134031970981], {
  icon: numero47,
});
let marcador48 = L.marker([3.6813330292647453, 112.26247986323905], {
  icon: numero48,
});
let marcador49 = L.marker([-17.61230638837263, 109.01001979880137], {
  icon: numero49,
});
let marcador50 = L.marker([5.653717760336705, 65.32732727446829], {
  icon: numero50,
});
let marcador51 = L.marker([1.5757338953395152, 58.514194304253785], {
  icon: numero51,
});
let marcador52 = L.marker([-3.2598321290078887, 54.999792295647104], {
  icon: numero52,
});
let marcador53 = L.marker([4.338621904100812, 44.320187877388236], {
  icon: numero53,
});
let marcador54 = L.marker([4.077437898502696, 17.514187263428276], {
  icon: numero54,
});
let marcador55 = L.marker([-7.545889831330513, 6.34963190564168], {
  icon: numero55,
});
let marcador56 = L.marker([-10.149778716742073, -19.05181061869142], {
  icon: numero56,
});
let marcador57 = L.marker([-18.906394957479332, -11.755570701153566], {
  icon: numero57,
});
let marcador58 = L.marker([-31.473615267811606, 155.5036661578497], {
  icon: numero58,
});
let marcador59 = L.marker([-41.066910674587824, 131.1675315147351], {
  icon: numero59,
});
let marcador60 = L.marker([-45.74323734595705, 163.23366246845714], {
  icon: numero60,
});
let marcador61 = L.marker([-48.61757152994217, 80.4315181146359], {
  icon: numero61,
});
let marcador62 = L.marker([-53.685455471910636, 27.162119232155717], {
  icon: numero62,
});
let marcador63 = L.marker([-37.13570279808544, -16.326960447458546], {
  icon: numero63,
});
let marcador64 = L.marker([-18.849124125277413, -159.1889194304254], {
  icon: numero64,
});

export {
  marcador1,
  marcador2,
  marcador3,
  marcador4,
  marcador5,
  marcador6,
  marcador7,
  marcador8,
  marcador9,
  marcador10,
  marcador11,
  marcador12,
  marcador13,
  marcador14,
  marcador15,
  marcador16,
  marcador17,
  marcador18,
  marcador19,
  marcador20,
  marcador21,
  marcador22,
  marcador23,
  marcador24,
  marcador25,
  marcador26,
  marcador27,
  marcador28,
  marcador29,
  marcador30,
  marcador31,
  marcador32,
  marcador33,
  marcador34,
  marcador35,
  marcador36,
  marcador37,
  marcador38,
  marcador39,
  marcador40,
  marcador41,
  marcador42,
  marcador43,
  marcador44,
  marcador45,
  marcador46,
  marcador47,
  marcador48,
  marcador49,
  marcador50,
  marcador51,
  marcador52,
  marcador53,
  marcador54,
  marcador55,
  marcador56,
  marcador57,
  marcador58,
  marcador59,
  marcador60,
  marcador61,
  marcador62,
  marcador63,
  marcador64,
  marcardorEnfoqueEntrada,
  marcadorEnfoqueEquinos,
  marcadorAvestruz,
  marcadorBanoGanaderia,
  marcadorCaninos,
  marcadorEquinos,
  marcadorEspecies,
  marcadorFelinos,
  marcadorGanaderia,
  marcadorGranja,
  marcadorParqueadero1,
  marcadorParqueadero2,
  marcadorParqueadero3,
  marcadorPorcicultura,
  marcadorSericultura,
  marcadorBanoEquinos,
  marcadorBanoEspecies,
  marcadorBanoPorci,
  marcadorRestauranteCaninos,
  marcadorRestauranteEquinos,
  marcadorRestauranteEspecies,
  marcadorRestauranteFelinos,
  marcadorRestauranteGanaderia,
  marcadorRestaurantePorci,
  iconoUser,
};
